import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { SocialSidebar } from '../components/common/SocialSidebar';

export const PublicLayout: React.FC = () => {
    return (
        <div className="flex min-h-screen flex-col bg-background text-foreground font-sans relative overflow-x-clip">
            <SocialSidebar />
            <PublicHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <PublicFooter />
        </div>
    );
};
